'use strict';

module.exports = '3.27.0';



// WEBPACK FOOTER //
// ./~/instantsearch.js/~/algoliasearch/src/version.js